import { MembershipGiftMode } from "../enum";


export function membershipGiftModeFilter(input) {

    switch (input) {

        case MembershipGiftMode.NONE:
            return "Geen welkomstcadeau";
        case MembershipGiftMode.SINGLE:
            return "Eén welkomstcadeau";
        case MembershipGiftMode.SINGLE_CHOICE:
            return "Eén welkomstcadeau uit keuzelijst";
        case MembershipGiftMode.MULTIPLE:
            return "Meerdere welkomstcadeau's uit keuzelijst";

        default:
            return "";
    }
}